import {connect} from 'react-redux';
import Header from './Header';

const getActualState = (state) =>(
    {
        state
    }
)

const actions = (dispatch) =>(
    {
        eventsActions: (type,payload) => dispatch({type,...payload})
    }
)

export default connect(getActualState,actions)(Header);